import { GetterTree } from 'vuex';
import { IProfileState } from './profile-state.store';
import { IRootState } from '../root-state.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
import { ITeamMember } from '../../models/profile/member.model';
import { IMemberParameter } from '../../models/profile/member.parameter';
import { CrudStatus } from '../../common/enums';

export const getters: GetterTree<IProfileState, IRootState> = {
  service: (state: IRootState) => state.service
  , activityStatus: (state: IRootState): ActivityStatus => {
    return state.activityStatus;
  },
  members: (state: IProfileState ) : Map<string,any[]> => state.members,
  totalPages: (state: IProfileState ) : number => state.total_pages,
  totalItems: (state: IProfileState ) : number => state.pagination.totalItems,
  paginationTotal: (state: IProfileState) : number => state.pagination.total_pages,
  paginationPage: (state: IProfileState) : number => state.pagination.page,
  entityRoles: (state: IProfileState ) : any[] => state.entity_roles,
  internalEntityRoles: (state: IProfileState ) : any[] => {
    return state.internal_entity_roles
  },
  externalEntityRoles: (state: IProfileState ) : any[] => {
    return state.external_entity_roles
  },
  civilities: (state: IProfileState) : { id: number, text: string }[] => state.civilities,
  currentFilter: (state: IProfileState ) : string => state.current_filter,
  member: (state: IProfileState ) : ITeamMember => state.member,
  currentMember: (state: IProfileState ) : ITeamMember => state.currentMember,
  memberParameter: ( state: IProfileState ) : IMemberParameter => state.memberParameter,
  memberSelection: (state: IProfileState ) : number[] => state.memberSelection,
  profileCrudActionStatus: (state: IProfileState ) : CrudStatus => state.crudActionStatus,
  loaders: (state: IProfileState) : Map<string,boolean> => state.loaders,
  closingReason: (state: IProfileState ) => state.closingReason,
  ticketSubstatus : (state: IProfileState ) => state.ticketSubstatus,
  ticketReason : (state: IProfileState ) => state.ticketReason,
}



// WEBPACK FOOTER //
// ./src/store/profile/profile-getters.store.ts